import Box from "/app/src/components/generic/components/box";
import { Divider } from "@heroui/react";
import PrimaryMapping from "./primaryMapping";
import { Integration } from "/app/src/models";
import { Mappings } from "/app/src/components/generic/components/apps/data/mappings";

/**
 *
 * @param param0 integration
 * @returns DataMappings component
 */
export default function DataMappings({
  integration,
}: {
  integration: Integration;
}) {
  return (
    <Box>
      <PrimaryMapping integration={integration} />
      <Divider className="my-6" />
      <Mappings box={false} integration={integration} />
    </Box>
  );
}
